import { TThunkAction } from '../../types/redux';
import { selectActivePaymentMethod } from '../../selectors/paymentMethods';
import { EPaymentMethodType, EPaymentProvider } from '../../types/redux/paymentMethods';
import { payByLinkedCardThunk } from '../payByLinkedCard';
import { payByCloudPaymentsThunk } from '../cloudPayments/payByCloudPayments';
import { payByYooKassaThunk } from '../yooKassa/payByYooKassa';
import { setWidgetError, setWidgetStatus } from '../../actions/layout';
import { EWidgetMode, EWidgetStatus } from '../../types/redux/layout';
import { validateFormThunk } from '../validateForm';
import { beforePaymentThunk } from '../beforePayment';
import { selectWidgetMode } from '../../selectors/layout';

export const startPaymentThunk: TThunkAction = async (dispatch, getState) => {
  const state = getState();
  const { paymentProvider, type } = selectActivePaymentMethod(state);
  const mode = selectWidgetMode(state);

  dispatch(setWidgetError(null));

  const isValid = dispatch(validateFormThunk);

  if (!isValid) {
    return;
  }

  dispatch(setWidgetStatus(EWidgetStatus.Loading));

  if (mode === EWidgetMode.Payment) {
    await dispatch(beforePaymentThunk);
  }

  switch (true) {
    case type === EPaymentMethodType.LinkedCard:
      dispatch(payByLinkedCardThunk);
      break;

    case paymentProvider === EPaymentProvider.YooKassa:
      dispatch(payByYooKassaThunk);
      break;

    case paymentProvider === EPaymentProvider.CloudPayments:
      dispatch(payByCloudPaymentsThunk());
      break;
  }
};
